import { Injectable } from "@angular/core";
import { TrainEvaluationFrontendParameter } from "../models/TrainEvaluationFrontendParameter.model";
import { BaseEvaluationService } from "./BaseEvaluationService";

@Injectable()
export class TrainEvaluationService extends BaseEvaluationService<TrainEvaluationFrontendParameter> {
    constructor() {
        super();
    }

    public initializeEvaluationFrontendParameter() {
        super.initializeEvaluationFrontendParameter(new TrainEvaluationFrontendParameter());
    }
}